import axios from "axios";
import * as AppSettingsService from "../AppSettingsService";
import {
  BillingHistoryParams,
  RefundTransactionRequestBody,
} from "../../types/PaymentTransactionTypes";
import qs from "querystring";

const appSettings = AppSettingsService;

export const getBillingHistory = async (params: BillingHistoryParams) => {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetWandaBillingHistory`;

    const paymentTypeIdsQuery = params.PaymentTransactionTypeIds?.map(
      (id: number) => `PaymentTransactionTypeIds=${id}`
    ).join("&");

    const { PaymentTransactionTypeIds, ...rest } = params;

    const serializedParams = qs.stringify({ ...rest });

    const queryString = [serializedParams, paymentTypeIdsQuery]
      .filter(Boolean)
      .join("&");

    const response = await axios.get(`${baseUrl}?${queryString}`);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const refundTransactionByPaymentInstrumentId = async (
  paymentTransactionId: number,
  requestBody: RefundTransactionRequestBody
) => {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/common/Payments/v1/Transaction/${paymentTransactionId}/Refund`;
    const response = await axios.post(baseUrl, requestBody);
    return response.data;
  } catch (error) {
    throw error;
  }
};
